import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {IExceptionTable} from '../../models/timetable';

@Component({
  selector: 'app-set-hours-exeption',
  templateUrl: './set-hours-exeption.component.html',
  styleUrls: ['./set-hours-exeption.component.scss'],
  animations: [fadeInAnimation]
})
export class SetHoursExeptionComponent implements OnInit {

  @Input() exceptions: IExceptionTable[] = [];
  @Input() disabled: boolean;
  @Output() openNewException: EventEmitter<any> = new EventEmitter();
  @Output() removeException: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  onOpenModalNewException(): void {
    this.openNewException.emit(true);
  }

  onRemoveException(exeptionId): void {
    this.removeException.emit(exeptionId);
  }
}
